import {
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import { InputWrapper, LabelStyle } from "../../styles/form";
import { FilterOption } from "../columnFilterTypes";

type Props = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  options?: FilterOption[];
  showLabel?: boolean;
};

const YesNoFilterField = ({
  label,
  value,
  onChange,
  options,
  showLabel = true,
}: Props) => {
  const opts = options ?? [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  return (
    <FormControl sx={{ ...InputWrapper, mb: showLabel ? 0 : 0, width: "100%" }}>
      {showLabel && label && <FormLabel sx={LabelStyle}>{label}</FormLabel>}
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as string)}
        fullWidth
        displayEmpty
        renderValue={
          value
            ? undefined
            : () => (
                <Typography sx={{ color: "#c1cccf" }}>Any</Typography>
              )
        }
        endAdornment={
          value ? (
            <InputAdornment sx={{ marginRight: "10px" }} position="end">
              <IconButton onClick={() => onChange("")} size="small">
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ) : undefined
        }
      >
        {opts.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default YesNoFilterField;
